/* HELP
Its parent needs to be positioned (relative, absolute etc)

Properties
- text
- show
- positionLeft (optional)

*/
import { useEffect, useRef, useState } from "react";
import { usePopperTooltip } from "react-popper-tooltip";

import styles from './InfoIconWithTooltip.module.css';

const InfoIconWithTooltip = (props) => {
  const [textWidth, setTextWidth] = useState(10);
  const textRef = useRef(null);
  // Info tooltip with Popper package
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({
    interactive: true,
    // delayHide: 40
  });

  useEffect(() => {
    // console.log("textRef.current: ", textRef.current)
    if (textRef && textRef.current) {
      // console.log("textRef.current: ", textRef.current)
      const fiberNode = Object.entries(textRef.current)[0][1]
      // console.log("fiberNode: ", fiberNode)
      const textLength = fiberNode.child.stateNode.firstChild.length;
      // const textLength = fiberNode.stateNode.firstChild.length; // OLD approach, before having multiple separated lines
      const compStyles = window.getComputedStyle(textRef.current);
      // console.log("compStyles: ", compStyles)
      const textFontSize = parseFloat(compStyles.fontSize.replace('px', ''));
      // console.log("textFontSize: ", textFontSize)
      const pixelsPerChar = Math.ceil(textFontSize);
      // console.log("pixelsPerChar: ", pixelsPerChar)
      const width = textLength * pixelsPerChar;
      // console.log("width: ", width);
      setTextWidth(width);
    }

  }, [textRef.current])

  const infoIcon = (
    <div
      className={`${(props.show && props.text) ? "visible" : "invisible"} ${styles.infoIcon} overflow-visible p-0`}
      // data-bs-toggle="tooltip" 
      // data-bs-placement="top"
      // title="Tooltip on top"
      type="button" ref={setTriggerRef}
    ></div>
    // <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tooltip on top">
    //   Tooltip on top
    // </button>
  );

  const textSections = props.text && props.text.split("\n").map((el, index) => {
    const txt = `- ${el}`;
    return (
    <span className="d-block">{txt}</span>
    )})


  const tooltipText = <p
    ref={textRef}
    className={styles.text}
    style={{ width: `${textWidth}px` }}
  >
    {textSections && textSections}
    {/* {props.text} */}
  </p>


  return (
    <div className={`${styles.infoIconContainer} d-flex justify-content-center`} style={props.positionLeft ? {left: "2px"} : {right: "-2px"}}>
      {/* TOOLTIP  */}
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: `${styles.animated} ${styles.infoTooltip} tooltip-container` })}
        >
            {/* for the css classes used go to node_modules\react-popper-tooltip\dist\styles.css  */}
          <div {...getArrowProps({ className: `${styles.tooltipArrow} tooltip-arrow` })} />

          {tooltipText}
        </div>
      )}
      {/* {props.questionType && infoTooltip} */}
      {infoIcon}
    </div>
  );
}

export default InfoIconWithTooltip;